module.exports = __webpack_public_path__ + "img/align-justify.df71eba9.svg";